import React, { memo } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { intersection } from "lodash";
/*
 * This is the route utility component used for generating
 * routes and child routes it only requires routes array and basePath
 */
const MapAllowedRoutes = ({ routes, isAddNotFound, location }) => {
  return (
    <Switch location={location}>
      {routes.map((item) => {
        const {
          route,
          component: Component,
          children,
          title,
          permission,
          ...rest
        } = item;
        return <Route component={Component} key={route} path={route} />;
      })}

      <Redirect exact from="/" to={routes[0].route} />
    </Switch>
  );
};

export function getAllowedRoutes(routes, role) {
  return routes.filter(({ permission }) => {
    if (!permission) return true;
    else if (!isArrayWithLength(permission)) return true;
    else return intersection(permission, [role]).length;
  });
}

export function isArrayWithLength(arr) {
  return Array.isArray(arr) && arr.length;
}

export default MapAllowedRoutes;
